import { useEffect, useState } from 'react';
import { IntersectionOption } from './types';


export const useIntersection = (id: string, rootMargin: string, checkVisible?: boolean) => {
    const [isVisible, setVisible] = useState(false);
    useEffect(() => {
      const options: IntersectionOption = {
        rootMargin,
      };
      if (checkVisible) {
        options.trackVisibility = true;
        options.delay = 100;
        options.threshold = [1.0];
      }
      const element = document.getElementById(id);
      // in case of filter id this is breaking because filter section is not visible. Adding quick fix
      if (!element) {
        return;
      }
      const observer = new IntersectionObserver(([entry]) => {
        if (checkVisible) {
          setVisible(entry?.isVisible);
          return;
        }
        setVisible(entry.isIntersecting);
      }, options);

      element && observer.observe(element);

      return () => observer.unobserve(element);
    }, [id, rootMargin, checkVisible]);
    return isVisible;
  };
